var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 32C72 25.6348 69.4714 19.5303 64.9706 15.0294C60.4697 10.5286 54.3652 8 48 8C41.6348 8 35.5303 10.5286 31.0294 15.0294C26.5286 19.5303 24 25.6348 24 32C24 60 12 68 12 68H84C84 68 72 60 72 32Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9201 84C54.2168 85.2123 53.2074 86.2186 51.993 86.9181C50.7785 87.6176 49.4016 87.9858 48.0001 87.9858C46.5986 87.9858 45.2216 87.6176 44.0072 86.9181C42.7927 86.2186 41.7833 85.2123 41.0801 84",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBell;